/*
 * @Descripttion: 互联网医院处方上传
 * @version:
 * @Author: leon
 * @Date: 2026-09-24
 */
import { API_PREFIX } from './constant'
import { Request } from './request'

// 互联网医院处方上传请求体
export interface InternetHospitalPrescriptionUploadDTO {
  // 患者信息
  patient?: Record<string, any>
  // 就诊信息
  treatment?: Record<string, any>
  // 互联网医院编码，当前支持 KJ
  hospitalCode: string
  // 好医点处方 ID
  recipeId?: number | null
}

// 手动上传处方至互联网医院
export function uploadInternetHospitalPrescription(
  body: InternetHospitalPrescriptionUploadDTO
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/internet-hospital/prescription/upload`,
    method: 'POST',
    body,
  }
}


export interface PrescriptionQueryListParams {
  current?: any
  size?: any
  patientName?: any
  insuranceCode?: any
  recipeCategory?: any
  status?: any
  settlementStatus?: any
  prescribeTimeStart?: any
  prescribeTimeEnd?: any
}
// 分页查询互联网医院处方单列表
export function getInternetHospitalPrescriptionPage(params: PrescriptionQueryListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/internet-hospital/prescription/page`,
    method: 'GET',
    params,
  }
}


export interface InternetHospitalPrescriptionDetailDTO {
  recipeId?: any
}

// 查询互联网医院处方单详情
export function getInternetHospitalPrescriptionDetail(
  params: InternetHospitalPrescriptionDetailDTO
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/internet-hospital/prescription/detail/recipe`,
    method: 'GET',
    params
  }
}

// 导出互联网医院处方单列表
export function exportInternetHospitalPrescription(body: PrescriptionQueryListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/internet-hospital/prescription/export`,
    method: 'POST',
    responseType: 'blob',
    body,
  }
}
